export default function signInWithCustomToken(_ref) {
  var app = _ref.app,
      firebaseToken = _ref.firebaseToken;
  return app.auth().signInWithCustomToken(firebaseToken);
}